import { LegalNoteLink, nextLine } from "components/mlpaUiComponents/LegalNote/lib";

export default {
  address: `
    ${nextLine()}Oranienburger Str. 45
    ${nextLine()}10117 Berlin
  `,
  contact: "Kontakt",
  footerTitle: "FGW e.V. - Fördergesellschaft Windenergie und andere Dezentrale Energien",
  copyrightString: "© 2024 FGW e.V. Alle Rechte vorbehalten.",
  eMail: "info@zerez.net",
  eula: "AGB",
  faq: "FAQ",
  fundedBy: "Gefördert durch (Förderkennzeichen: 03MAP427)",
  fundingCode: "Förderkennzeichen: 03MAP427",
  imprint: "Impressum",
  officiallyAppointed: `FGW e. V. ist beliehene Stelle gem. ${LegalNoteLink({
    url: "https://www.bundesanzeiger.de/pub/publication/ghCqAifY5ZGYr6EK5bX/content/ghCqAifY5ZGYr6EK5bX/BAnz%20AT%2013.03.2025%20B1.pdf?inline",
    ariaLabel: "Link to",
    label: "Beleihungsbescheid",
  })}`,
  phone: "+49 (0)30 / 30 10 15 05-0",
  privacyPolicy: "Datenschutz",
  runBy: "Betrieben von",
  contactTooltip: "Wir freuen uns auf Ihre Nachricht!",
  downloadFileTooltip: "Dokument herunterladen",
};
